module.exports = __webpack_public_path__ + "img/Feature.9b760b5a.png";